import React from 'react';
import { useTranslation } from 'react-i18next';
import type { WishlistItem } from '../../services/wishlistService';

interface WishlistCardProps {
    item: WishlistItem;
    hasVoted: boolean;
    onClick: (item: WishlistItem) => void;
    currentLanguage: string;
}

const WishlistCard: React.FC<WishlistCardProps> = ({ item, hasVoted, onClick, currentLanguage }) => {
    const { t } = useTranslation(['wishlist', 'common']);

    const topicLabel = item.node
        ? (item.node.labels[currentLanguage] || item.node.labels['en'] || item.node.code)
        : item.customTopic || '';

    const statusColors: Record<string, string> = {
        open: '#22c55e',
        in_progress: '#f59e0b',
        fulfilled: '#667eea',
        declined: '#94a3b8',
    };

    return (
        <div className="wishlist-card wishlist-card--clickable" onClick={() => onClick(item)}>
            <div className="wishlist-card__header">
                <span
                    className="wishlist-card__status"
                    style={{ backgroundColor: statusColors[item.status] || '#94a3b8' }}
                >
                    {t(`wishlist:status_${item.status}`)}
                </span>
                {item.node && (
                    <span className="wishlist-card__tag">{item.node.code}</span>
                )}
            </div>

            <h3 className="wishlist-card__topic">{topicLabel}</h3>

            {item.description && (
                <p className="wishlist-card__description">{item.description}</p>
            )}

            <div className="wishlist-card__footer">
                <div className="wishlist-card__user">
                    {item.user?.fullName || item.user?.username || ''}
                </div>

                <div className={`wishlist-card__vote-badge ${hasVoted ? 'wishlist-card__vote-badge--voted' : ''}`}>
                    <svg width="14" height="14" viewBox="0 0 14 14" fill={hasVoted ? '#667eea' : 'none'} stroke={hasVoted ? '#667eea' : 'currentColor'} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M7 2L8.75 5.5H12.25L9.625 7.75L10.5 11.5L7 9.25L3.5 11.5L4.375 7.75L1.75 5.5H5.25L7 2Z" />
                    </svg>
                    <span>{item.voteCount}</span>
                </div>
            </div>

            {item.status === 'fulfilled' && item.fulfilledCourse && (
                <div className="wishlist-card__fulfilled">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M3.5 7L6 9.5L10.5 4.5" />
                    </svg>
                    <a href={`/courses/${item.fulfilledCourse.id}`} onClick={(e) => e.stopPropagation()}>
                        {item.fulfilledCourse.title}
                    </a>
                </div>
            )}
        </div>
    );
};

export default WishlistCard;
